<template>
  <v-layout :loading="loading">
    <template v-if="!loading">
      <d-header :actions="actions" fluid>
        <h1 class="title">
          {{ user.name }}
        </h1>
      </d-header>
      <v-form action="edit" :user="user" @success="fetch()" />
    </template>
  </v-layout>
</template>

<script>
import form from "./_form.vue";

export default {
  metaInfo() {
    return {
      title: this.user.name,
      __user: this.user.name, // for breadcrumb
    };
  },
  components: {
    "v-form": form,
  },
  data() {
    return {
      user: {},
      loading: true,
    };
  },
  computed: {
    actions() {
      const actions = [];

      if (this.user.can.impersonate) {
        actions.push({
          label: this.$t("impersonate"),
          icon: "account-arrow-right",
          color: "is-grey",
          primary: true,
          action: () => {
            location.href = route("impersonate", this.user.id);
          },
        });
      }

      return actions;
    },
  },
  watch: {
    "$route.params.user"() {
      this.fetch();
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http
        .get(route("api.users.show", { user: this.$route.params.user }))
        .then((response) => {
          this.loading = false;
          this.user = response.data.data;
        })
        .catch(() => {
          this.$router.push("/users");
        });
    },
  },
};
</script>
